// Beaker
import BeakerA from "./img/Beaker/beaker_a.svg";
import BeakerB from "./img/Beaker/beaker_b.svg";
import BeakerC from "./img/Beaker/beaker_c.svg";
import BeakerD from "./img/Beaker/beaker_d.svg";
import BeakerE from "./img/Beaker/beaker_e.svg";
import BeakerF from "./img/Beaker/beaker_f.svg";

// Blotting Paper
import Blotting_Paper from "./img/Blotting_Paper.svg";

// Biohazardous_Waste.svg
import Biohazardous from "./img/Biohazardous_Waste.svg";

// CellSpreader
import CellSpreader from "./img/cell-spreader.svg";

// ChromatographyColumn
import ChromatographyColumn from "./img/column-blue-full-closed.svg";

// Dialysis tube
import DialysisTube from "./img/dialysis_tube.svg";

// Electronic balance
import ElectronicBalance from "./img/electronic_balance.svg";

// Paper towels
import PaperTowels from "./img/paper_towels.svg";

// Petridish
import petridishLB from "./img/petri-dish-lb.svg";
import petridishLBAMP from "./img/petri-dish-lb-amp.svg";
import petridishLBAMPARA from "./img/petri-dish-lb-amp-ara.svg";

// Pipette
import P2_Pipette from "./img/Micropipette/P2_Micropipette.svg";
import P20_Pipette from "./img/Micropipette/P20_Micropipette.svg";
import P200_Pipette from "./img/Micropipette/P200_Micropipette.svg";
import P1000_Pipette from "./img/Micropipette/P1000_Micropipette.svg";

// Tip Box
import P2_Tip_Box from "./img/TipBox/P2_Tip_Box.svg";
import P20_Tip_Box from "./img/TipBox/P20_Tip_Box.svg";
import P200_Tip_Box from "./img/TipBox/P200_Tip_Box.svg";
import P1000_Tip_Box from "./img/TipBox/P1000_Tip_Box.svg";

// Solution
import SolutionFalconBB from "./img/Solution/falcon-bb.svg";
import SolutionFalconCEB from "./img/Solution/falcon-ceb.svg";
import SolutionFalconEB from "./img/Solution/falcon-eb.svg";
import SolutionFalconWB from "./img/Solution/falcon-wb.svg";

import SDSBuffer from "./img/Solution/SDSBuffer.svg";
import cellCulture from "./img/Solution/cellCulture.svg";
import proteinLadder from "./img/Solution/proteinLadder.svg";

// Flask
import OneX_Sodium_Borate_Buffer from "./img/flaskDarkBlue.svg";
import OneX_Sodium_Borate_Buffer_Light from "./img/flaskLightBlue.svg";

// Freezer
import freezer_closed from "./img/freezer-closed.svg";

// Floating Tube Rack
import floatingTubeRack from "./img/floating-solution-tube-rack-empty.svg";

// Gel
import Agarose_Gel from "./img/Agarose_Gel.svg";

// Polyacrylamide Gel
import PolyacrylamideGel from "./img/Polyacrylamide_Gel.svg";

// Gel Box
import Gel_Electrophoresis_Box from "./img/Electrophoresis_Box.svg";
import Protein_Gel_Electrophoresis_Box from "./img/Protein_Gel_Electrophoresis_Box.svg";

// Ice Bucket
import IceBucket from "./img/Ice_Bucket.svg";

// Incubator
import Incubator from "./img/incubator.svg";

// Lab Tape
import LabTape from "./img/lab-tape.svg";

// Microcentrifuge
import Microcentrifuge from "./img/Microcentrifuge.svg";
import MicrocentrifugeNew from "./img/MicrocentrifugeNew.svg";

// Power Suply
import Power_Supply from "./img/Power_Supply.svg";

// Power Supply New
import Power_Supply_New from "./img/Power_Supply_New.svg";

// Power Suply Leads
import Power_Supply_Leads from "./img/Power_Supply_Leads.svg";

// Trash
import Trash from "./img/Trash.svg";

// Timer
import Timer from "./img/timer.svg";

// Vortex
import Vortex from "./img/vortex.svg";

// Water Bath
import WaterBath from "./img/Water Bath.svg";

// Waste Collection Jar
import WasteCollectionJar from "./img/waste_collection_jar.svg";

// Heat Block
import HeatBlock from "./img/heatBlock.svg";

export default {
  BeakerA,
  BeakerB,
  BeakerC,
  BeakerD,
  BeakerE,
  BeakerF,
  Blotting_Paper,
  Biohazardous,
  CellSpreader,
  ChromatographyColumn,
  DialysisTube,
  ElectronicBalance,
  PaperTowels,
  P2_Pipette,
  P20_Pipette,
  P200_Pipette,
  P1000_Pipette,
  P2_Tip_Box,
  P20_Tip_Box,
  P200_Tip_Box,
  P1000_Tip_Box,
  SolutionFalconBB,
  SolutionFalconCEB,
  SolutionFalconEB,
  SolutionFalconWB,
  SDSBuffer,
  cellCulture,
  proteinLadder,
  petridishLB,
  petridishLBAMP,
  petridishLBAMPARA,
  OneX_Sodium_Borate_Buffer,
  OneX_Sodium_Borate_Buffer_Light,
  freezer_closed,
  floatingTubeRack,
  Agarose_Gel,
  PolyacrylamideGel,
  Gel_Electrophoresis_Box,
  Protein_Gel_Electrophoresis_Box,
  IceBucket,
  LabTape,
  Microcentrifuge,
  MicrocentrifugeNew,
  Power_Supply,
  Power_Supply_New,
  Power_Supply_Leads,
  Trash,
  Timer,
  Vortex,
  WaterBath,
  Incubator,
  WasteCollectionJar,
  HeatBlock,
};
